import axios from 'axios'
import {Message, MessageBox} from 'element-ui'
import router from '@/router'
let count = 0

// 创建axios实例
const service = axios.create({
    baseURL: process.env.BASE_API, // api 的 base_url
    timeout: 120000, // 请求超时时间
    // 跨域携带cookie
    withCredentials: true
})

// response 拦截器
service.interceptors.response.use(
    response => {
        return response.data
    },
    error => {
        const response = error.response;
        if(!response) {//调不通，返回null
            return
        }
        const res = response.data
        // 401:未登录;
        if (response.status === 401) {
            const { path, fullPath } = router.currentRoute
            
            // 如果当前不在登录页面，则跳转登录页面
            if (path !== '/login') {
                count +=1 
                if (count === 1) {
                MessageBox.alert('登录超时，请重新登录', {
                    confirmButtonText: '确定',
                    showClose: false,
                    callback: action => {
                        count = 0
                     // 跳转登录页面
                        router.replace({
                            path: '/login',
                            query: {redirect: fullPath}//登录成功后跳入浏览的当前页面
                        })
                        localStorage.removeItem('application:ctn')
                    }
                  });
                }
            }
        } else if (response.status === 403 || response.status === 405) { // 403:无权限访问; 405:密码到期，需要强制修改密码;
            //router.replace({path: '/'})
            Message({
                message: res.errorMsg || response.status,
                type: 'warning',
                duration: 2 * 1000
            })
        } else if(response.status === 404) {
            router.replace({path: '/404'})
        } else if(response.status === 500 || response.status === 518) {// 服务端异常
            //router.replace({path: '/error'})
            Message({
                message: res.errorMsg || response.status,
                type: 'error',
                duration: 5 * 1000
            })
        } else if (response.status === 417) {//登录发生异常
            Message({
                message: '登录异常',
                type: 'error',
                duration: 5 * 1000
            })
        }
        return Promise.reject(error)
    }
)

export default service
